// extracted by mini-css-extract-plugin
export default {"App":"Ide_App__qQW+w","ideContainer":"Ide_ideContainer__DGEI9","timer":"Ide_timer__rYLjh"};